import { css } from "styled-components";
import token from "styled-token";

var defaultCSS = function defaultCSS(props) {
  return token({
    backgroundColor: "Radio.backgroundColor",
    borderColor: "Radio.borderColor",
    borderColorDisabled: "Radio.borderColorDisabled",
    borderRadius: "radii.ellipse",
    borderWidth: "Radio.borderWidth",
    focusBoxShadow: "shadows.focus",
    size: "Radio.size"
  }, function (tokens) {
    return css(["appearance:none;outline:none;box-shadow:none;box-sizing:border-box;display:inline-block;height:", "px;width:", "px;background:", ";border:", "px solid ", ";border-radius:", ";cursor:pointer;margin:0;"], tokens.size, tokens.size, tokens.backgroundColor, tokens.borderWidth, props.disabled || props["aria-disabled"] ? tokens.borderColorDisabled : tokens.borderColor, tokens.borderRadius);
  })(props);
};

var hoverCSS = function hoverCSS(props) {
  return token({
    borderColor: "Input.borderColorInteractive"
  }, function (tokens) {
    return css(["border-color:", ";"], tokens.borderColor);
  })(props);
};

var checkedCSS = function checkedCSS(props) {
  return token({
    borderColor: "Input.borderColorInteractive",
    borderWidth: "Radio.borderWidthChecked"
  }, function (tokens) {
    return css(["border-color:", ";border-width:", "px;"], tokens.borderColor, tokens.borderWidth);
  })(props);
};

var focusCSS = function focusCSS(props) {
  return token({
    boxShadow: "shadows.focus"
  }, function (tokens) {
    return css(["box-shadow:", ";"], tokens.boxShadow);
  })(props);
};
/** @mixin radioStateMixin */

/** @method */


export var radioStateMixin = function radioStateMixin(state) {
  return function (props) {
    switch (state) {
      case "hover":
        return hoverCSS(props);

      case "checked":
        return checkedCSS(props);

      case "focus":
        return focusCSS(props);

      default:
        return defaultCSS(props);
    }
  };
};